import React from 'react';
import {
  Card,
  CardHeaderNumber
} from './MetricsCard';

export default function TotalClientsCard({ metrics }) {
  return (
    <Card title="Total Clients on Check This Out">
      <CardHeaderNumber>{metrics.totalClients.toString()}</CardHeaderNumber>
    </Card>
  );
}
